import type { ApolloClient } from '@apollo/client';
import type { AppDispatch } from '../store';
import { GET_USER, GET_PROFILE } from '../graphql/queries';
import { fetchUserSuccess, setCurrentUserProfile } from '../store/slices/userSlice';

/**
 * GET_USER でユーザーを取得し、Redux に反映する。
 * profileId はあるが nested profile が返らない場合（AppSync のフィールド解決の取りこぼし等）に
 * getProfile を続けて呼び、setCurrentUserProfile で補完する。
 */
export async function fetchAndHydrateCurrentUser(
  client: ApolloClient<object>,
  dispatch: AppDispatch,
  userId: string
): Promise<void> {
  try {
    const res = await client.query({
      query: GET_USER,
      variables: { userId },
      fetchPolicy: 'network-only',
    });
    const user = res.data?.getUser;
    if (!user) {
      return;
    }

    dispatch(fetchUserSuccess(user));

    const profileId = typeof user.profileId === 'string' ? user.profileId.trim() : '';
    if (profileId && !user.profile) {
      const pr = await client.query({
        query: GET_PROFILE,
        variables: { profileId },
        fetchPolicy: 'network-only',
      });
      const profile = pr.data?.getProfile;
      if (profile) {
        dispatch(setCurrentUserProfile(profile));
      }
    }
  } catch (error) {
    console.error('ユーザー詳細情報の取得に失敗しました:', error);
  }
}
